<template>

  <main class="main main_main-page">

    <transition
      name="image"
      mode="in-out"
      :duration="600"
    >

      <div
        v-if="loaded"
        :key="currentSlide.id"
        :style="{ 'background-image': `url(${ currentSlide.image })` }"
        :class="{ 'image_blurred' : detailedView }"
        class="image image_slide-background"
      ></div>

    </transition>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      viewBox="0 0 100 100"
      class="figure figure_main-background"
    >

      <path ref="figurePath" fill="#FFF" d="M0 0 H37.5 L18.75 100 H0 Z"></path>

    </svg>

    <section ref="section" class="section section_slide">

      <section class="section__item section__item_left">

        <div ref="special" class="special">

          <div class="special__container">

            <a
              @click.prevent="onClickSpecialLink"
              href="#"
              class="special__link"
            >About us</a>

            <div
              @click="onClickSpecialTitle"
              @mouseenter="onMouseEnterSpecialTitle"
              @mouseleave="onMouseLeaveSpecialTitle"
              class="special__title"
            >Professionals</div>

            <div class="special__caption">Creativit&agrave; e&nbsp;razionalit&agrave;. Il&nbsp;giusto mix tra l&rsquo;innovazione dei creativi e&nbsp;la&nbsp;nostra esperienza di&nbsp;field marketing. Siamo nati cos&igrave;, nel 1996. Gi&agrave; in&nbsp;fase di&nbsp;ideazione eliminiamo le&nbsp;proposte non realizzabili, garantendo la&nbsp;certezza dell&rsquo;attuazione, facendo risparmiare tempo e&nbsp;denaro.</div>

          </div>

        </div>

        <div
          ref="captionSlideMove"
          class="caption caption_slide-move"
        >Scroll</div>

      </section>

      <section class="section__item section__item_right">

        <a
          v-show="detailedView"
          @click.prevent="onClickBack"
          class="link link_white link_back-to-short-view"
          href="#"
        >Back</a>

        <div ref="slide" class="slide" v-if="loaded">

          <div class="slide__container">

            <transition
              name="title"
              :duration="600"
            >

              <div
                :key="currentSlide.id"
                @click="onClickSlideTitle"
                @mouseenter="onMouseEnterSlideTitle"
                @mouseleave="onMouseLeaveSlideTitle"
                :class="{ 'slide__title_default' : slideIndex === 0 }"
                class="slide__title"
              >{{ currentSlide.title }}</div>

            </transition>

            <div class="slide__content">

              <div class="indicator indicator_slide">
                <span class="indicator__marker">{{ slideIndex | leadingZero }}</span>/{{ slidesCount - 1 | leadingZero }}
              </div>

              <div class="service service_slide">

                <transition
                  name="service"
                  :duration="800"
                >

                  <div
                    :key="currentSlide.id"
                    class="service__container"
                  >

                    <div class="service__name">{{ currentSlide.name }}</div>

                    <div
                      v-html="currentSlide.short_desc"
                      class="service__short-desc"
                    ></div>

                    <transition
                      name="v01"
                      :duration="400"
                    >

                      <div
                        v-show="detailedView && videoPath"
                        class="service__video-wrapper">
                        <video
                          v-bind:controls="videoControls"
                          :src="videoPath"
                          class="service__video">
                        </video>
                        <div
                          v-show="videoPreview"
                          @click="onClickVideo"
                          class="service__video-play">
                        </div>
                      </div>

                    </transition>

                    <transition
                      name="v01"
                      :duration="400"
                    >

                      <div
                        v-show="detailedView"
                        v-html="currentSlide.desc"
                        class="service__full-desc"
                      ></div>

                    </transition>

                    <div
                      v-show="currentSlide.desc && !detailedView"
                      class="service__more"
                    >

                      <a
                        @click.prevent="onClickLearnMore"
                        class="link link_white"
                        href="#"
                      >Learn more</a>

                    </div>

                  </div>

                </transition>

              </div>

            </div>

          </div>

        </div><!-- .slide -->

        <div
          v-if="loaded && nextSlide !== null"
          v-show="detailedView"
          @click="onClickCaptionTitleNextSlide"
          class="caption caption_title-next-slide"
        >{{ nextSlide.url_title }}</div>

      </section>

    </section>

  </main>

</template>

<script>
  import TouchHandler from '@/js/TouchHandler';
  import Utils from '@/mixins/Utils';
  import axios from 'axios';

  export default {
    name: 'MainPage',

    components: {},

    filters: {
      leadingZero(value) {
        return value > 9 ? value : `0${value}`;
      },
    },

    mixins: [
      Utils,
    ],

    props: {
      slideURL: {
        type: String,
        default: null,
      },
    },

    data() {
      return {
        detailedView: false,
        loaded: false,
        slides: [],
        slideURLs: [],
        touchArea: null,
        videoPreview: true,
        videoControls: false,
        videoPlay: false,
        videoPath: false,
      };
    },

    computed: {
      slidesCount() {
        return this.slides.length;
      },

      slideIndex() {
        const index = this.slideURLs.indexOf(this.slideURL);

        if (index === -1) {
          this.$router.replace({name: 'NotFound'});
        }

        return index;
      },

      indexNextSlide() {
        const slidesCount = this.slidesCount;
        const nextIndex = this.slideIndex + 1;
        const condition = nextIndex > slidesCount - 1;

        return condition ? null : nextIndex;
      },

      indexPrevSlide() {
        const prevIndex = this.slideIndex - 1;
        const condition = prevIndex < 0;

        return condition ? null : prevIndex;
      },

      currentSlide() {
        return this.slides[this.slideIndex];
      },

      nextSlide() {
        const indexNextSlide = this.indexNextSlide;

        return indexNextSlide === null ? null : this.slides[indexNextSlide];
      },
    },

    watch: {
      $route() {
        if (this.detailedView) {
          this.toggleDetailedView();

          this.toggleSide({
            isLeftSide: false,
            show: false,
          });
        }
      },
    },

    created() {
      document.body.classList.add('body_main-page');
      // @TODO
      // Выяснить почему последний узел сбрасывает устанавливаемый класс без
      // обёртки $nextTick
      this.$nextTick(() => {
        this.toggleClasses(true);
      });

      this.setUrlByIndex = this.setUrlByIndex();
      this.onWheelWindow = debounce(this.onWheelWindow, 100);

      this.fetchData();

      window.addEventListener('resize', this.onResizeWindow);
    },

    mounted() {
      this.touchArea = new TouchHandler(this.$el);
    },

    beforeUpdate() {
      this.setVideoPath();
    },

    beforeDestroy() {
      document.body.classList.remove('body_main-page');

      this.toggleClasses(false);
      this.$emit('switchLogo', {variant: 0});

      window.removeEventListener('resize', this.onResizeWindow);

      window.removeEventListener('wheel', this.onWheelWindow);
      window.removeEventListener('keyup', this.onKeyup);
    },

    methods: {
      fetchData() {
        this.$http.get('/static/api/main.json')

        .then(this.onFulfilled);
      },

      setVideoPath() {
        axios
          .get(`/api/videos/${this.slideURL}`)
          .then((response) => {
            this.videoPath = response.data.video_path;
          })
          .catch((error) => {
            this.videoPath = false;
          });
      },

      calculateHeightWindow() {
        const htmlNode = document.documentElement;
        const slideNode = this.$refs.slide;
        const slideCompStyle = getComputedStyle(slideNode);
        const slideMarginTop = +slideCompStyle.marginTop.match(/(\d+)/gi)[0];
        const slideHeight = slideNode.clientHeight + slideMarginTop;

        const windowHeight = window.innerHeight;

        if (windowHeight > slideHeight) {
          htmlNode.style.height = `${ windowHeight }px`;
        } else {
          htmlNode.style.height = `${ slideHeight }px`;
        }
      },

      setUrlByIndex() {
        let isWaiting = false;

        return (index) => {
          if (
            index !== null &&
            this.slideIndex !== index &&
            !isWaiting
          ) {
            isWaiting = true;

            const path = this.slideURLs[index] !== null
              ? this.slideURLs[index]
              : '';

            this.$router.push({path: `/${ path }`});

            setTimeout(() => {
              isWaiting = false;
            }, 850);
          }
        };
      },

      toggleDetailedView() {
        const sectionNode = this.$refs.section;
        const slideNode = this.$refs.slide;

        if (this.detailedView) {
          this.$emit('switchLogo', {variant: 0});
          this.$emit('switchNavSwitch', {variant: 0});
          this.showFigure();
          this.touchArea.on('swipeY', this.onSwipeY);

          sectionNode.classList.remove('section_detailed-view');
          slideNode.classList.remove('slide_detailed-view');

          window.addEventListener('keyup', this.onKeyup);
          window.addEventListener('wheel', this.onWheelWindow);

          this.detailedView = false;
          this.videoControls = false;
          this.videoPreview = true;
          let video = document.querySelector('.service__video');
          video.pause();

          document.documentElement.style.height = null;
        } else {
          this.$emit('switchLogo', {variant: 1});
          this.$emit('switchNavSwitch', {variant: 1});
          this.hideFigure();
          this.touchArea.off('swipeY', this.onSwipeY);

          sectionNode.classList.add('section_detailed-view');
          slideNode.classList.add('slide_detailed-view');

          window.removeEventListener('wheel', this.onWheelWindow);
          window.removeEventListener('keyup', this.onKeyup);

          this.detailedView = true;

          this.$nextTick(() => {
            this.calculateHeightWindow();
          });

          this.setVideoPath();
        }
      },

      toggleSide(options = {}) {
        if (this.isMobile || this.detailedView) {
          return;
        };

        const {
          isLeftSide = true,
          show = true,
        } = options;

        const figurePath = this.$refs.figurePath;
        const sectionNode = this.$refs.section;
        const specialNode = this.$refs.special;
        const captionNodeSlideMove = this.$refs.captionSlideMove;

        if (show && isLeftSide) {
          sectionNode.classList.add('section_collapse-right');
          specialNode.classList.add('special_test');
          captionNodeSlideMove.classList.add('caption_hide');
          this.$emit('hideFooter');
        } else if (!show && isLeftSide) {
          sectionNode.classList.remove('section_collapse-right');
          specialNode.classList.remove('special_test');
          captionNodeSlideMove.classList.remove('caption_hide');
          this.$emit('showFooter');
        } else if (show && !isLeftSide) {
          sectionNode.classList.add('section_collapse-left');
          specialNode.classList.add('special_hide');
          this.$emit('switchLogo', {variant: 2});
        } else {
          sectionNode.classList.remove('section_collapse-left');
          specialNode.classList.remove('special_hide');
          this.$emit('switchLogo', {variant: 0});
        }

        this.animate({
          duration: 400,

          draw(progress) {
            let topWidth = null;
            let bottomWidth = null;
            let path = null;

            if (show && isLeftSide) {
              topWidth = 37.5 + 62.5 * progress;
              bottomWidth = 18.75 + 81.25 * progress;
            } else if (!show && isLeftSide) {
              topWidth = 100 - 62.5 * progress;
              bottomWidth = 100 - 81.25 * progress;
            } else if (show && !isLeftSide) {
              topWidth = 37.5 - 31.25 * progress;
              bottomWidth = 18.75 - 12.5 * progress;
            } else {
              topWidth = 6.25 + 31.25 * progress;
              bottomWidth = 6.25 + 12.5 * progress;
            }

            path = `M0 0 H${ topWidth } L${ bottomWidth } 100 H0 Z`;
            figurePath.setAttribute('d', path);
          },
        });

        setTimeout(function() {
            const el = document.getElementsByClassName('special__caption');
            if (show && !isLeftSide) {
              el[0].style.display = 'none';
            } else {
              el[0].style.display = 'block';
            }
        }, 410);
      },

      onFulfilled(res) {
        const data = res.data.filter((item) => item.hide !== true);

        this.slides = data;
        this.slideURLs = this.slides.map((item) => item.url);
        this.loaded = true;

        this.touchArea.on('swipeY', this.onSwipeY);
        window.addEventListener('keyup', this.onKeyup);
        window.addEventListener('wheel', this.onWheelWindow);
      },

      onSwipeY(direction) {
        if (direction === 'swipeup') {
          this.setUrlByIndex(this.indexPrevSlide);
        } else {
          this.setUrlByIndex(this.indexNextSlide);
        }
      },

      onKeyup(e) {
        switch (e.keyCode) {
          case 38:
            this.setUrlByIndex(this.indexPrevSlide);
            break;
          case 40:
            this.setUrlByIndex(this.indexNextSlide);
          default:
            break;
        }
      },

      onClickLearnMore() {
        const options = {
          isLeftSide: false,
        };

        this.toggleSide(options);
        this.toggleDetailedView();
      },

      onClickSlideTitle() {
        if (this.isMobile || this.currentSlide.id === 0) {
          return;
        }

        this.toggleDetailedView();
      },

      onClickBack() {
        const options = {
          isLeftSide: false,
          show: false,
        };

        this.toggleDetailedView();
        this.toggleSide(options);
      },

      onMouseEnterSpecialTitle() {
        this.toggleSide();
      },

      onMouseLeaveSpecialTitle() {
        const options = {
          show: false,
        };

        this.toggleSide(options);
      },

      onMouseEnterSlideTitle() {
        const options = {
          isLeftSide: false,
        };

        this.toggleSide(options);
      },

      onMouseLeaveSlideTitle() {
        const options = {
          isLeftSide: false,
          show: false,
        };

        this.toggleSide(options);
      },

      onResizeWindow() {
        if (this.detailedView) {
          this.calculateHeightWindow();
        }
      },

      onClickCaptionTitleNextSlide() {
        this.setUrlByIndex(this.indexNextSlide);
      },

      onClickVideo() {
        this.videoPreview = false;
        this.videoControls = 'controls';
        this.videoPlay = true;
        let video = document.querySelector('.service__video');
        video.play();
      },

      onWheelWindow(e) {
        if (e.deltaY > 0) {
          this.setUrlByIndex(this.indexNextSlide);
        } else {
          this.setUrlByIndex(this.indexPrevSlide);
        }
      },

      hideFigure() {
        const figurePath = this.$refs.figurePath;

        this.animate({
          duration: 400,

          draw(progress) {
            const topWidth = 6.25 - 6.25 * progress;
            const bottomWidth = 6.25 - 6.25 * progress;
            const path = `M0 0 H${ topWidth } L${ bottomWidth } 100 H0 Z`;

            figurePath.setAttribute('d', path);
          },
        });

        this.$emit('switchLogo', {variant: 1});
      },

      showFigure() {
        const figurePath = this.$refs.figurePath;

        this.animate({
          duration: 400,

          draw(progress) {
            const topWidth = 6.25 * progress;
            const bottomWidth = 6.25 * progress;
            const path = `M0 0 H${ topWidth } L${ bottomWidth } 100 H0 Z`;

            figurePath.setAttribute('d', path);
          },
        });

        this.$emit('switchLogo', {variant: 2});
      },

      onClickSpecialLink() {
        this.moveToAboutUsPage();
      },

      onClickSpecialTitle() {
        this.moveToAboutUsPage();
      },

      moveToAboutUsPage() {
        this.$refs.special.classList.add('special_test_2');

        setTimeout(() => {
          this.$router.push({name: 'AboutUs'});
        }, 400);
      },
    },
  };

  /**
   * @param {Function} f
   * @param {Number} ms
   * @return {Function}
   */
  function debounce(f, ms) {
    let state = null;

    /** @this Vue */
    return function(...args) {
      if (state) {
        return;
      };

      f.apply(this, args);

      state = true;

      setTimeout(() => {
        state = null;
      }, ms);
    };
  }
</script>



// WEBPACK FOOTER //
// src/pages/main/Index.vue